import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";
import { KendoModule } from "src/app/modules/kendo.module";
import { FormsModule } from '@angular/forms';
import { SarAllocationComponent } from "../components/sar-allocation/sar-allocation.component";

@NgModule({ declarations: [
        SarAllocationComponent,
    ],
    exports: [
        SarAllocationComponent,
    ], imports: [FormsModule,
        BrowserModule,
        RouterModule,
        KendoModule], providers: [
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class SarAllocationModule { }